module.exports = __webpack_public_path__ + "img/NorseCapTechFreyjasBlessing.83a7c32b.webp";